import { createSlice } from "@reduxjs/toolkit";

const workflowSlice = createSlice({
  name: "db4",
  initialState: {
    clientAppointments: [],
    pageSize: 50,
    displayArchiveOnly: false,
    archivedClientAppointments: [],
    historyClientAppointments: [],
    // ARCHIVED and HISTORY come from a listener over every non-WORKFLOW
    // status, most of the collection. It starts only once a screen asks for
    // it, so logging in downloads just the WORKFLOW tab.
    isOtherClientAppointmentsRequested: false,
    isOtherClientAppointmentsLoaded: false,
  },
  reducers: {
    setClientAppointments(state, action) {
      const { clientAppointments = [] } = action.payload;
      state.clientAppointments = clientAppointments;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setDisplayArchiveOnly(state, action) {
      state.displayArchiveOnly = action.payload;
    },
    setArchivedClientAppointments(state, action) {
      const { archivedClientAppointments = [] } = action.payload;
      state.archivedClientAppointments = archivedClientAppointments;
    },
    setHistoryClientAppointments(state, action) {
      const { historyClientAppointments = [] } = action.payload;
      state.historyClientAppointments = historyClientAppointments;
    },
    requestOtherClientAppointments(state) {
      state.isOtherClientAppointmentsRequested = true;
    },
    setOtherClientAppointmentsLoaded(state, action) {
      state.isOtherClientAppointmentsLoaded = action.payload;
    },
    resetOtherClientAppointments(state) {
      state.isOtherClientAppointmentsRequested = false;
      state.isOtherClientAppointmentsLoaded = false;
      state.archivedClientAppointments = [];
      state.historyClientAppointments = [];
    },
  },
});

export const {
  setClientAppointments,
  setPageSize,
  setDisplayArchiveOnly,
  setArchivedClientAppointments,
  setHistoryClientAppointments,
  requestOtherClientAppointments,
  setOtherClientAppointmentsLoaded,
  resetOtherClientAppointments,
} = workflowSlice.actions;

export default workflowSlice.reducer;
